module.exports = __webpack_public_path__ + "static/media/map-marker-alt-solid.c5171472.svg";